<template>
    <div class="content">
        <div class="tit-mod-secs clearfix">
            <h3 class="fl font-s16">最新新闻</h3>
        </div>
        <div class="blank40"/>
        <div v-for="(item, index) in newNews" :key="index" class="news">
            <a :href="`/detail?id=${item.id}`">
                <img v-if="item.image" :src="item.image">
                <span>{{item.title}}</span>
            </a>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'newNews'
    ])
}
</script>
<style lang="scss" scoped>
.content{
    width: 300px;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 0 1px #f0f0f0;
    background-color: #fff;
    padding: 0 0 30px 0;
}
.news{
    width: 100%;
    padding-bottom: 20px;
    a, a:link {
        cursor: pointer;
        color: #333 !important;
        text-decoration: none;
    }
    img{
        width: 100%;
        height: 214px;
        border-radius: 8px;
        transition: all .3s ease;
    }
    img:hover{
        transform:scale(1.06,1.06)
    }
    span{
        display: block;
        width: 100%;
        font: 500 16px/30px "Microsoft YaHei";
        padding-top: 10px;
    }
    span:hover{
        color: #326fd4;
    }
}
</style>
